import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'

export interface DraftInReviewProgressionProActionsContainerProps {
  vm: JobProgressionViewModel
}

export const DraftInReviewProgressionProActionsContainer = observer(
  function DraftInReviewProgressionProActionsContainer({
    vm,
  }: DraftInReviewProgressionProActionsContainerProps) {
    if (!vm.isAnyExtensionFlowAvailable) {
      return null
    }

    return <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
  },
)
